export default "__VITE_ASSET__f01eac73__"